export const isInternalUrl = (url: string): boolean => url?.startsWith('/') || url?.startsWith('.');
